import { Order, PackageDetail, PackageInformation } from "src/models";

export type Packages = {
    loading: boolean;
    order?: Order;
    smsSent: boolean;
    sendingGiftCode: boolean;
    giftCodeApplied: boolean;
    packages: PackageInformation[];
    packageListLoaded: boolean;
    currentPackage?: PackageDetail;
};

export const PackagesInitialState: Packages = {
    loading: false,
    smsSent: false,
    sendingGiftCode: false,
    giftCodeApplied: false,
    packageListLoaded: false,
    packages: [],
};